import { PathRoutes } from 'common/constants';
import LibertyChangePageButton from 'components/basics/LibertyChangePageButton/LibertyChangePageButton';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export const SwitchSupplementsAnnulments = () => {
  const navigate = useNavigate();
  const optionsList = useMemo(
    () => [
      {
        name: 'Producción',
        tooltip: null,
        action: () => navigate(PathRoutes.QUERIES),
        id: 'id_to_consultation_button'
      },
      {
        value: 'Renovación',
        name: 'Renovaciones',
        tooltip: null,
        action: () => navigate(PathRoutes.RENOVATIONS),
        id: 'id_to_renovation_button'
      },
      {
        name: 'Siniestros',
        tooltip: null,
        action: () => navigate(PathRoutes.SINISTERS),
        id: 'id_to_sinister_button'
      }
    ],
    [navigate]
  );

  return (
    <LibertyChangePageButton title={'Otras consultas'} options={optionsList} buttonStyles={true} />
  );
};
